import React from 'react';
import {
  StyledSection,
  StyledCloudImage,
  StyledTitle,
  StyledContainer,
  StyledBox,
  StyledButtonContainer,
  StyledFeature,
  StyledButton,
  StyledButtonContainerMobile,
  StyledSectionContainer,
} from '@sections/registry/HeroSection/HeroSection.styles';
import { Flex } from '@components/Flex';
import { JoykitIcon } from '@components/JoykitIcon';
import { getCreateWeddingUrl } from '@utils/urlHelpers.util';
import { useTranslation } from 'react-i18next';

interface HeroSectionProps {}

export const HeroSection: React.FC<HeroSectionProps> = () => {
  const { t } = useTranslation('registry');
  const registryHero = t('registryHero');
  return (
    <StyledSection as="section" id="Registry_Hero">
      <StyledSectionContainer>
        <StyledBox>
          <StyledCloudImage
            src="registry-q12024/hero/wedding-registry-hero-image.png"
            alt="wedding registry hero"
            isEagerLoading={true}
            fetchPriority="high"
            optimization="aggressive"
            mobileResizeWidth={400}
          />
          <StyledTitle tagName="h1" variant="hed56" color="mono1">
            {registryHero.title}
          </StyledTitle>
        </StyledBox>
        <StyledContainer>
          {registryHero.features.map((feature, idx) => (
            <Flex key={idx} alignItems="center">
              <JoykitIcon name="checkmark" color="mono1" />
              <StyledFeature tagName="p" variant="sectionEyeBrow20" color="mono1">
                {feature}
              </StyledFeature>
            </Flex>
          ))}
          <StyledButtonContainer flexDirection="row">
            <StyledButton id="registryHeroGetStartedBtn" variant="primary" forwardedAs={'a'} href={getCreateWeddingUrl('registry')}>
              {registryHero.cta1Label}
            </StyledButton>
            <StyledButton id="registryHeroFindACoupleBtn" variant="secondary" forwardedAs={'a'} href="/find">
              {registryHero.cta2Label}
            </StyledButton>
          </StyledButtonContainer>
        </StyledContainer>
      </StyledSectionContainer>
      <StyledButtonContainerMobile flexDirection="row">
        <StyledButton id="registryHeroGetStartedBtnMobile" variant="primary" forwardedAs={'a'} href={getCreateWeddingUrl('registry')}>
          {registryHero.cta1Label}
        </StyledButton>
        <StyledButton id="registryHeroFindACoupleBtnMobile" variant="secondary" forwardedAs={'a'} href="/find">
          {registryHero.cta2Label}
        </StyledButton>
      </StyledButtonContainerMobile>
    </StyledSection>
  );
};
